import axios from "axios";

const TOKEN_KEY = "vavlis.at";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && (!cfg.url.includes("/auth/") || cfg.url.includes("/auth/me"))) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        setToken(data.access_token);
        return api(cfg);
      } catch (refreshErr) {
        const d = refreshErr.response?.data?.detail;
        setToken(null);
        if (d === "customer_inactive" || d === "User not found") {
          if (d === "customer_inactive") sessionStorage.setItem("vavlis.inactive", "1");
          window.dispatchEvent(new Event("vavlis:signedout"));
        }
      }
    }
    return Promise.reject(err);
  }
);
